export default __webpack_public_path__ + "media/images/images/flags/ks-5c18bcd783b9bd5db86e1f5e5b5c6792.png";